import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { useAtomValue } from 'jotai';

import { userAtom } from 'v2/atoms/userAtom';
import { UserRole } from 'v2/constants';
import { AppRoute } from 'v2/routes';

export const RootPage: FC = () => {
  const user = useAtomValue(userAtom);

  if (user?.roles.includes(UserRole.ADMIN)) {
    return <Navigate to={AppRoute.TOURNAMENT_SETTINGS_PAGE} />;
  }

  if (user?.roles.includes(UserRole.MODERATOR)) {
    return <Navigate to={AppRoute.DAILY_BONUSES_SETTINGS_PAGE} />;
  }

  if (user?.roles.includes(UserRole.SELLS_ADMIN)) {
    return <Navigate to={AppRoute.VIP_SETTINGS_PAGE} />;
  }

  if (user?.roles.includes(UserRole.SUPPORT_ADMIN) || user?.roles.includes(UserRole.SUPPORT)) {
    return <Navigate to={AppRoute.USER_SETTINGS_PAGE} />;
  }
};
